import moment from 'moment-timezone';
import { useEffect, useState } from 'react';

const useTimer = ({ isActive, endTime }) => {
  /*   const Ref = useRef(null);
  const [timer, setTimer] = useState('24:00:00');
  const today = moment();

  const getTimeRemaining = e => {
    const total = Date.parse(e) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor((total / 1000 / 60 / 60) % 24);
    return {
      total,
      hours,
      minutes,
      seconds
    };
  };

  const startTimer = e => {
    let { total, hours, minutes, seconds } = getTimeRemaining(e);
    if (total >= 0) {
      setTimer(
        (hours > 9 ? hours : '0' + hours) +
          ':' +
          (minutes > 9 ? minutes : '0' + minutes) +
          ':' +
          (seconds > 9 ? seconds : '0' + seconds)
      );
    } else {
      setTimer('00:00:00');
    }
  };

  const clearTimer = e => {
    if (!isActive) {
      if (Ref.current) clearInterval(Ref.current);
      Ref.current = setInterval(() => {
        startTimer(e);
      }, 1000);
    } else {
      setTimer('00:00:00');
    }
  };

  const getDeadTime = () => {
    const deadline = new Date();
    const diffSeconds = endTime.diff(today, 'seconds');
    deadline.setSeconds(deadline.getSeconds() + diffSeconds);
    return deadline;
  };

  useEffect(() => {
    clearTimer(getDeadTime());
    return () => clearInterval(Ref.current);
  }, []);

  useEffect(() => {
    if (timer === '00:00:00') clearInterval(Ref.current);
    // return () => clearInterval(Ref.current);
  }, [timer]); */

  const [timer, setSetTimer] = useState('24:00:00');

  useEffect(() => {
    if (!isActive) {
      if (timer === '00:00:00') {
      } else {
        const intervalId = setInterval(() => {
          updateRemainingTime(endTime);
        }, 1000);
        return () => clearInterval(intervalId);
      }
    }
  }, [endTime, isActive, timer]);

  function updateRemainingTime(countdown) {
    const { hours, minutes, seconds } = getRemainingTimeUntilMsTimestamp(countdown);
    setSetTimer(`${hours}:${minutes}:${seconds}`);
  }

  return { timer, setSetTimer };
};

function getRemainingTimeUntilMsTimestamp(timestampMs) {
  const timestampDayjs = moment(timestampMs);
  const nowDayjs = moment();
  if (timestampDayjs.isBefore(nowDayjs)) {
    return {
      seconds: '00',
      minutes: '00',
      hours: '00'
    };
  }
  return {
    seconds: getRemainingSeconds(nowDayjs, timestampDayjs),
    minutes: getRemainingMinutes(nowDayjs, timestampDayjs),
    hours: getRemainingHours(nowDayjs, timestampDayjs)
  };
}

function getRemainingSeconds(nowDayjs, timestampDayjs) {
  const seconds = timestampDayjs.diff(nowDayjs, 'seconds') % 60;
  return padWithZeros(seconds, 2);
}

function getRemainingMinutes(nowDayjs, timestampDayjs) {
  const minutes = timestampDayjs.diff(nowDayjs, 'minutes') % 60;
  return padWithZeros(minutes, 2);
}

function getRemainingHours(nowDayjs, timestampDayjs) {
  const hours = timestampDayjs.diff(nowDayjs, 'hours') % 24;
  return padWithZeros(hours, 2);
}

function padWithZeros(number, minLength) {
  const numberString = number.toString();
  if (numberString.length >= minLength) return numberString;
  return '0'.repeat(minLength - numberString.length) + numberString;
}

export default useTimer;
